const UIkit = window.UIkit;
import axios from "axios";

export default function() {
    const classNameToWatch = 'catTitle-active';

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                const oldClass = mutation.oldValue;

                const hadClass = oldClass?.split(/\s+/).includes(classNameToWatch);
                const hasClass = target.classList?.contains(classNameToWatch);
                var dropdown = document.querySelector("#custom-cat-nav .uk-navbar-dropbar");

                if (hadClass && !hasClass) {
                    const others = document.querySelectorAll(`.${classNameToWatch}`);
                    if (others.length === 0) {
                        dropdown?.classList?.add('uk-hidden');
                    }
                }
                else if (hasClass) {
                    dropdown?.classList?.remove('uk-hidden');
                }
            }
        }
    });

    observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class'],
        attributeOldValue: true
    });

    UIkit.util.on(document, 'beforeshow', '#custom-cat-nav .uk-navbar-dropdown', function (e) {
        const elem = e.target,
            id = elem.dataset.id,
            dropdowngrid = document.querySelector('#custom-cat-nav [data-id="' + elem.dataset.id + '"] .uk-navbar-dropdown-grid'),
            translations = window.CbxTranslations,
            expandWithChildren = false,
            itemChildLimit = elem.dataset.expandLimit ?? 5;

        const chunkArray = (array, chunkSize) => Array(Math.ceil(array.length / chunkSize))
                .fill()
                .map((_, index) => index * chunkSize)
                .map(begin => array.slice(begin, begin + chunkSize));
                
        axios.get('/contextapi/' + window.CbxApiContextKey + '/v1/productcategories/children/' + id + (expandWithChildren ? '?expandWithChildren=true' : ''))
            .then(function (response) {
                let html = '';

                const limit = 18;
                let showMore = false;
                if (response.data.children.length > limit)
                {
                    showMore = true;
                    response.data.children = response.data.children.splice(0, limit);
                }

                // group children into 4 columns
                    let colSize = Math.ceil(response.data.children.length / 4);
                    if (expandWithChildren) colSize = 1;
                    const chunks = chunkArray(response.data.children, colSize);
                    chunks.forEach(chunk => {
                        html += ``;
                        chunk.forEach(item => {
                        const active = false;

                        let children = ``;
                        let count = 0;
                        if (item.children?.length)
                        {
                            children += `<ul class="uk-nav uk-navbar-dropdown-nav">`;
                            item.children.every(child => {
                                children += `
                                <li>
                                    <a class="uk-text-small category-item-title uk-padding-remove uk-text-inherit category-button" href="${child.link}">${child.title}</a>
                                </li>`;

                                count++;

                                if (count == itemChildLimit)
                                {
                                    children += `
                                    <li>
                                        <a class="uk-text-small uk-padding-remove uk-text-inherit uk-text-bold" href="${item.link}">${translations?.actions?.showMore ?? 'Show more'}</a>
                                    </li>`;

                                    return false;
                                }

                                return true;
                            });
                            children += `</ul>`;
                        }

                        html += `
                            <ul class="uk-nav uk-navbar-dropdown-nav cat-dropdown-item">
                            <a class="product-image uk-position-relative" href="${item.link}">
                                <img src="${item.previewimageurl}" width="150" height="125" />
                            </a>
                            <li class="category-button category-button-parent ${(active ? 'uk-active' : '')}">
                                <strong class="uk-margin-bottom"><a href="${item.link}">${item.title}</a></strong>
                                ${children}
                            </li>
                            </ul>
                        `;
                    });

                    //if (chunks)
                    html += ``;
                });
                
                if (showMore)
                html += `<div class="uk-width-1 uk-text-center"><a class="uk-button uk-button-default" href="${response.data.parent.link}">${translations?.actions?.showMore ?? 'Show more'} <span uk-icon="icon: arrow-right"></span></a></div>`;
                
                dropdowngrid.innerHTML = html;
            })  
            .catch(function (error) {
                console.log(error)
            });
    });
}